export default "__VITE_ASSET__BQx3kaQH__"